// removed by extract-text-webpack-plugin
module.exports = {"globalMainColor":"#1a5276","successColor":"#4cb455","errorColor":"#ff5555","normalColor":"#e6ebf1","warningColor":"#ffa43b","infoColor":"#2db7f5","expireColor":"#c5c5c5","borderColor":"#ebeaf0","labelBorder":"#d5d8dd","textColor":"#4b4b4b","labelColor":"#909090","labelBg":"#f7f8fa","disabledColor":"#c5c8ce"};


//////////////////
// WEBPACK FOOTER
// ./src/assets/common.scss
// module id = 7TWk
// module chunks = 12